import { Modal } from "react-bootstrap";

import Fetching from "@/components/Fetching/Fetching";
import { usePreviewPdf } from "@/hooks/planning/application-order/appOrdersDocs";

import classes from "./oa-preview.module.scss";

const OAPreview = ({ code, onClose }) => {
	const { data, isFetching } = usePreviewPdf(code);

	if (!code) {
		return null;
	}

	return (
		<Modal show={Boolean(code)} dialogClassName={classes.modal} onHide={onClose} backdrop="static" keyboard={false}>
			<Modal.Header closeButton>
				<Modal.Title style={{ fontSize: "1em" }}>{`Vista Previa OA`}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{isFetching ? (
					<Fetching topMargin={"0px"} />
				) : (
					<div className={classes.divPreview}>
						<iframe className={classes.previewFrame} title="Preview" srcDoc={data?.html} />
					</div>
				)}
			</Modal.Body>
		</Modal>
	);
};

export default OAPreview;
